import React, { useEffect, useContext, useState } from 'react';
import { useAppContext } from '../../utils/contexts/appContext';
import { AuthContext } from '../../providers/AuthProvider';
import Loader from '../../components/loader/Loader';
import ModernisationsView from './modernisations-view';
import { useTranslation } from 'react-i18next';
import { Container } from '@material-ui/core';
import { ProjectTypeRepository } from '../../utils/dexie/repositories/project-type-repository';

const ModernisationsContainer = () => {
    const auth = useContext(AuthContext);
    const [t,] = useTranslation();
    const [, dispatch] = useAppContext();
    const [isLoading, setIsLoading] = useState(true);
    const [modernisationProjects, setModernisationProjects] = useState([]);
    const [projectTypes, setProjectTypes] = useState([]);

    useEffect(() => {
        dispatch({ type: 'changeHeader', header: { title: t("ModernisationProjects"), child: false } });
        
        if (navigator.onLine) {
            auth.getUser()
                .then((user) => {
                    auth.fetch('get', 'projects/driverapp')
                        .then(async (result) => {
                            if (result && result.status === 200) {
                                const projects = result.data;
                                const projectTypes = await ProjectTypeRepository.getAllProjectTypes();

                                setModernisationProjects(projects.sort((a, b) => a.customerName.localeCompare(b.customerName)));
                                setProjectTypes(projectTypes ?? []);
                                setIsLoading(false);
                            }
                        })
                });
        }
    }, [auth, dispatch, t]);

    return (
        <Container>
            {
                isLoading ?
                    <Loader /> :
                    <ModernisationsView projects={modernisationProjects} projectTypes={projectTypes} />
            }
        </Container>
    );
}

export default ModernisationsContainer;